<div class="ft-uploader-main-wrap ft-uploader-v2-wrap fb-upload-file">
  <input #file [hidden]="true" [disabled]="disabled" type="file" multiple="true" (change)="onFileSelected($event)" title="" accept="{{extensionListString}}" />
  <button
    mat-icon-button
    class="ft-uploader-v2-btn upload-button hidden-print"
    [disabled]="disabled"
    multiple="true"
    title="Select Files"
    (click)="file.click()"
    type=""
  >
    <mat-icon>attachment</mat-icon>
  </button>
  <input
    #camera
    [hidden]="true"
    [disabled]="disabled"
    type="file"
    id="input"
    accept="image/*"
    capture="camera"
    multiple="true"
    (change)="onFileSelected($event)"
    title=""
  />
  <button
    mat-icon-button
    #cameraButton
    [disabled]="disabled"
    (click)="hasPermission == 'granted' ? (isMobile ? camera.click() : openDialog()) : requestPermission()"
    class="ft-uploader-v2-btn upload-button hidden-print"
  >
    <mat-icon>camera_enhance</mat-icon>
  </button>

  <div
    class="ft-uploader-drop dropzone text-center hidden-print"
    appDragDropFileUpload
    (paste)="onPaste($event)"
    (fileDropped)="fileDropped($event)"
  >
    <span id="__{{ fieldName }}">{{ statusNote }}</span>
  </div>
</div>

<ng-template #permissionGrantedDialog>
  <div id="dialog">
    <button id="closeIcon" mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
    <div id="dialogContent">
      <mat-icon id="checkIcon">task_alt</mat-icon>
      <p>
        Permission to access your camera granted, click continue to open camera and take a photo.
      </p>
      <button mat-raised-button mat-dialog-close (click)="camera.click()" id="continueButton">
        Continue
      </button>
    </div>
  </div>
</ng-template>
